import * as ToggleGroup from "@radix-ui/react-toggle-group";
import classNames from "components/ui/classNames";

interface TickerSymbolSelectorProps {
  tickerSymbols: string[];
  value: string[];
  type?: "single" | "multiple";
  onChange: (tickerSymbols: string[]) => void;
}
export default function TickerSymbolSelector({
  tickerSymbols,
  value,
  type = "single",
  onChange,
}: TickerSymbolSelectorProps) {
  const isSingle = type === "single";

  return (
    <ToggleGroup.Root
      loop={true}
      type="multiple"
      className={classNames(
        "grid w-full grid-flow-col gap-x-2 rounded-xl border border-slate-200 bg-white p-1",
        "sm:flex sm:w-auto sm:justify-normal sm:space-x-2",
        "dark:border-slate-950 dark:bg-slate-700 dark:text-slate-300",
      )}
      orientation="horizontal"
      value={value}
      onValueChange={(tickerSymbols) => {
        if (isSingle) {
          const [firstValue] = value;
          onChange(tickerSymbols.filter((tickerSymbol) => tickerSymbol !== firstValue));
        } else {
          onChange(tickerSymbols);
        }
      }}
    >
      {tickerSymbols.map((tickerSymbol) => {
        return (
          <ToggleGroup.Item
            key={tickerSymbol}
            value={tickerSymbol}
            disabled={false}
            className={classNames(
              "h-9 w-full items-center justify-center rounded-xl p-1 px-3 font-mono",
              "border border-transparent text-sm font-medium tracking-wide text-slate-500",
              "data-[state=on]:bg-blue-50 data-[state=on]:font-bold data-[state=on]:text-blue-600",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-100 focus-visible:ring-offset-1 focus-visible:ring-offset-gray-300",
              "data-[state=on]:focus-visible:rounded-xl data-[state=on]:focus-visible:bg-gray-50 data-[state=on]:focus-visible:text-gray-600",
              "dark:data-[state=on]:bg-blue-900 dark:data-[state=on]:text-blue-100",
              "dark:data-[state=on]:border-blue-950 dark:data-[state=off]:text-slate-400",
            )}
          >
            {tickerSymbol}
          </ToggleGroup.Item>
        );
      })}
    </ToggleGroup.Root>
  );
}
